import { create } from 'zustand';

interface AuthState {
  type: number | null;
  permissions: string[];
  isSuperAdmin: boolean;
  setAuth: (type: number | null, permissions: string[]) => void;
  clear: () => void;
  hasPermission: (key: string) => boolean;
}

const loadPermissions = (): string[] => {
  try {
    const raw = localStorage.getItem('permissions');
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

const loadType = (): number | null => {
  const stored = localStorage.getItem('userType');
  return stored !== null && stored !== '' ? Number(stored) : null;
};

/**
 * Store xác thực mới — phân quyền dựa trên `permissions` (mảng key dạng "module.action").
 * Khi `type === 1` (Super Admin) thì toàn quyền, không cần check permissions.
 */
const useAuthStore = create<AuthState>((set, get) => {
  const type = loadType();
  const permissions = loadPermissions();
  return {
    type,
    permissions,
    isSuperAdmin: type === 1,
    setAuth: (nextType, nextPerms) => {
      localStorage.setItem('userType', nextType === null ? '' : String(nextType));
      localStorage.setItem('permissions', JSON.stringify(nextPerms ?? []));
      set({
        type: nextType,
        permissions: nextPerms ?? [],
        isSuperAdmin: nextType === 1,
      });
    },
    clear: () => {
      localStorage.removeItem('userType');
      localStorage.removeItem('permissions');
      set({ type: null, permissions: [], isSuperAdmin: false });
    },
    hasPermission: (key: string) => {
      const { isSuperAdmin, permissions } = get();
      if (isSuperAdmin) return true;
      if (!key) return true;
      return permissions.includes(key);
    },
  };
});

export default useAuthStore;

